import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, OverlayTrigger, Popover } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'

// token в external_couriers: голая строка у Яндекса/Uzum, JSON-объект у Millennium/Noor.
// Старые записи Noor бывают голым токеном — читаем его как { token }
function parseToken(token) {
	if (!token) return {}
	try {
		const parsed = JSON.parse(token)
		if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed
	} catch (e) { }
	return { token: token }
}

function isPlainToken(fields) {
	return fields.length === 1 && fields[0].key === 'token'
}

// Ключи, которых нет в списке полей (callback_auth, equipment_id…), сохраняем как были
function buildToken(fields, tokenConfig) {
	if (isPlainToken(fields)) return (tokenConfig.token ?? '').trim()

	const result = { ...tokenConfig }
	fields.forEach(field => {
		const value = typeof result[field.key] === 'string' ? result[field.key].trim() : result[field.key]
		if (value === '' || value === undefined || value === null) {
			delete result[field.key]
		} else if (field.type === 'number' && !isNaN(Number(value))) {
			result[field.key] = Number(value)
		} else {
			result[field.key] = value
		}
	})
	return JSON.stringify(result)
}

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [tokenConfig, setTokenConfig] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [externalCourierTypes, setExternalCourierTypes] = useState([])

	const selectedType = externalCourierTypes.find(option => option.id === selectedItem.external_courier_type_id)
	const tokenFields = selectedType?.token_fields ?? []

	async function searchWithFilter() {
		var filterUrl = "/external-couriers"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		const payload = {
			...selectedItem,
			is_active: selectedItem.is_active !== false,
		}
		// Список полей службы есть — токен собираем из них, иначе шлём поле TOKEN как раньше
		if (tokenFields.length > 0) {
			payload.token = buildToken(tokenFields, tokenConfig)
		}
		if (payload.id) {
			response = await PUT('/external-couriers', payload, { loader: true })
		} else {
			response = await POST('/external-couriers', payload, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
		}
	}

	async function toggleActive(item) {
		const payload = {
			...item,
			is_active: !item.is_active,
		}
		const response = await PUT('/external-couriers', payload, { loader: true })
		if (httpOk(response)) searchWithFilter()
	}

	function toggleModal(bool = false, item = {}) {
		if (bool && !item.id) {
			setSelectedItem({ is_active: true, poses: [] })
			setTokenConfig({})
		} else {
			setSelectedItem({
				...item,
				is_active: item.is_active !== false,
			})
			setTokenConfig(parseToken(item.token))
		}
		setShowModal(bool)
	}

	async function getexternalCourierTypes() {
		const response = await GET(`/helper/external-courier-types`)
		if (httpOk(response)) setExternalCourierTypes(response.data)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	useEffect(() => {
		searchWithFilter()
		getPoses()
		getexternalCourierTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('external_couriers')} [{data.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '25%' }}>{t('name2')}</th>
									<th style={{ 'width': '25%' }}>{t('type')}</th>
									<th style={{ 'width': '15%' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '35%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>
												{item.name}
											</span>
										</td>
										<td>{item.external_courier_type_name}</td>
										<td className="text-center">
											<div className="form-check d-flex justify-content-center mb-0">
												<input
													className="form-check-input"
													type="checkbox"
													checked={item.is_active !== false}
													onChange={() => toggleActive(item)}
												/>
											</div>
										</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				size="md"
				scrollable
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ height: 500 }}>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								autoFocus
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('type')}</label>
							{/* Тип при правке не меняется: бэкенд его не обновляет, а поля у служб разные */}
							<Select
								options={externalCourierTypes}
								value={selectedType || ''}
								isDisabled={!!selectedItem.id}
								onChange={(option) => {
									setSelectedItem({ ...selectedItem, 'external_courier_type_id': option.id })
									setTokenConfig({})
								}}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						{tokenFields.length > 0 &&
							<div className="border rounded p-2 mb-3">
								<small className="text-muted d-block mb-2">{t('ec_fields_title')}</small>
								{tokenFields.map(field => (
									<div className="form-group" key={field.key}>
										<label className="d-inline-flex align-items-center gap-1">
											<span>
												{t(field.label_key)}
												{field.required && <span className="required-mark">*</span>}
											</span>
											{field.hint_key &&
												<OverlayTrigger
													trigger={['hover', 'focus']}
													placement="top"
													overlay={
														<Popover id={`ec-hint-${field.key}`}>
															<Popover.Body>{t(field.hint_key)}</Popover.Body>
														</Popover>
													}
												>
													<i className="uil-question-circle text-primary cursor"
														style={{ fontSize: 16 }}
														role="button"
														tabIndex={0} />
												</OverlayTrigger>
											}
										</label>
										{field.type === 'select' ?
											<Select
												options={field.options.map(option => ({ value: option, label: option }))}
												value={tokenConfig[field.key] ? { value: tokenConfig[field.key], label: tokenConfig[field.key] } : null}
												onChange={(option) => setTokenConfig({ ...tokenConfig, [field.key]: option?.value ?? '' })}
												placeholder={field.placeholder ?? ''}
												isClearable
											/>
											:
											<input type="text" className="form-control"
												inputMode={field.type === 'number' ? 'numeric' : undefined}
												placeholder={field.placeholder ?? ''}
												value={tokenConfig[field.key] ?? ''}
												onChange={(e) => setTokenConfig({ ...tokenConfig, [field.key]: e.target.value })} />
										}
									</div>
								))}
							</div>
						}

						{selectedType && tokenFields.length === 0 &&
							<div className="form-group">
								<label>TOKEN</label>
								<input type="text" className="form-control" name="token"
									value={selectedItem.token ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'token': e.target.value })} />
							</div>
						}

						<div className="form-group">
							<label>{t('poses')}</label>
							<Select
								isMulti
								options={poses}
								value={selectedItem.poses}
								onChange={(options) => setSelectedItem({ ...selectedItem, 'poses': options })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-check mb-3">
							<input
								className="form-check-input"
								type="checkbox"
								id="external-courier-is-active"
								checked={selectedItem.is_active !== false}
								onChange={(e) => setSelectedItem({ ...selectedItem, is_active: e.target.checked })}
							/>
							<label className="form-check-label" htmlFor="external-courier-is-active">
								{t('status')}
							</label>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index
